import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../redux/store';
import { setAccountSettingsModals } from '../../redux/accountSettingsPage/accountSettingsSlice';
import NameEditModal from './NameEditModal';
import AccountDeleteConfirmationModal from './AccountDeleteConfirmationModal';
import BlockedUsersModal from './BlockedUsersModal';
import NotificationPreferencesModal from '../../components/PushNotifications/NotificationPreferencesModal';

const AccountSettingsPageModals = () => {
  const dispatch = useDispatch();
  const {
    isNameEditModalOpen,
    isDeleteAccountModalOpen,
    isBlockedUsersModalOpen,
    isNotificationPreferencesModalOpen,
  } = useSelector((state: RootState) => state.accountSettings.modals);

  const closeNameEditModal = () => {
    dispatch(setAccountSettingsModals({ isNameEditModalOpen: false }));
  };

  const closeDeleteAccountModal = () => {
    dispatch(setAccountSettingsModals({ isDeleteAccountModalOpen: false }));
  };

  const closeBlockedUsersModal = () => {
    dispatch(setAccountSettingsModals({ isBlockedUsersModalOpen: false }));
  };

  const closeNotificationPreferencesModal = () => {
    dispatch(
      setAccountSettingsModals({ isNotificationPreferencesModalOpen: false }),
    );
  };

  return (
    <>
      <NameEditModal
        isOpen={isNameEditModalOpen}
        handleClose={closeNameEditModal}
      />
      <AccountDeleteConfirmationModal
        isOpen={isDeleteAccountModalOpen}
        handleClose={closeDeleteAccountModal}
      />
      <BlockedUsersModal
        isOpen={isBlockedUsersModalOpen}
        handleClose={closeBlockedUsersModal}
      />
      <NotificationPreferencesModal
        isVisible={isNotificationPreferencesModalOpen}
        onClose={closeNotificationPreferencesModal}
      />
    </>
  );
};

export default AccountSettingsPageModals;
